const elecPriceZh = {
  elPriceLang: {
    请输入站点名称搜索: '请输入站点名称搜索',
    暂无数据: '暂无数据',
    电价配置: '电价配置',
    模板管理: '模板管理',
    动态电价: '动态电价',
    为对应月份选择模板后请点击绑定按钮以完成应用更换模板前请先点击解绑按钮才可重新选择: '为对应月份选择模板后，请点击“绑定”按钮以完成应用。更换模板前请先点击”解绑”按钮，才可重新选择。',
    年份: '年份',
    选择年份: '选择年份',
    '1月': 'January',
    '2月': 'February',
    '3月': 'March',
    '4月': 'April',
    '5月': 'May',
    '6月': 'June',
    '7月': 'July',
    '8月': 'August',
    '9月': 'September',
    '10月': 'October',
    '11月': 'November',
    '12月': 'December',
    请选择: '请选择',
    绑定: '绑定',
    当前: '当前',
    解绑: '解绑',
    查看: '查看',
    模板详情: '模板详情',
    模板名称: '模板名称',
    模板状态: '模板状态',
    使用中: '使用中',
    未使用: '未使用',
    使用情况: '使用情况',
    模板标签: '模板标签',
    开始时间: '开始时间',
    结束时间: '结束时间',
    时段: '时段',
    买入电价元kWh: '买入电价(元/kWh)',
    卖出电价元kWh: '卖出电价(元/kWh)',
    尖: '尖',
    峰: '峰',
    平: '平',
    谷: '谷',
    确定电价: '确定电价',
    是否确认解绑该模板: '是否确认解绑该模板？',
    提示: '提示',
    取消: '取消',
    点击引用模板按钮可将公共模板中的电价模板直接引用至当前页面下: '点击“引用模板”按钮，可将“公共模板”中的电价模板直接引用至当前页面下！',
    请输入内容例如模版名称标签: '请输入内容，例如模版名称、标签',
    查询: '查询',
    重置: '重置',
    引用模板: '引用模板',
    创建模板: '创建模板',
    模版名称: '模版名称',
    状态: '状态',
    标签: '标签',
    创建人: '创建人',
    创建时间: '创建时间',
    操作: '操作',
    引用创建: '引用创建',
    编辑: '编辑',
    删除: '删除',
    请选择站点: '请选择站点！',
    该模版正在使用中暂不支持删除请解绑后再操作: '该模版正在使用中，暂不支持删除，请解绑后再操作！',
    是否确认删除该模板: '是否确认删除该模板？',
    电价管理: '电价管理',
    选择需要引用的模板后点击确认按钮可将对应模板引用至模板管理中: '选择需要引用的模板后，点击“确认”按钮，可将对应模板引用至模板管理中。',
    请输入内容例如模版名称标签: '请输入内容，例如模版名称、标签',
    确定引用: '确定引用',
    请选择引用模板: '请选择引用模板！',
    模版编辑: '模版编辑',
    基础信息: '基础信息',
    时段与电价: '时段与电价',
    请输入模版名称: '请输入模版名称！',
    标签名称: '标签名称',
    请输入标签名称: '请输入标签名称！',
    标签名称以空格分隔完成后回车或点击生成按钮即可生成标签每个标签最多可输入20个字符最多支持生成10个标签:
      '标签名称以空格分隔，完成后回车或点击“生成”按钮即可生成标签。每个标签最多可输入20个字符，最多支持生成10个标签。',
    标签管理: '标签管理',
    点击编辑后可以勾选标签后进行删除操作: '点击“编辑”后，可以勾选标签后，进行删除操作',
    确定修改: '确定修改',
    下一步: '下一步',
    最多还可添加: '最多还可添加',
    个标签: '个标签',
    单个标签字符长度不可超过20: '单个标签字符长度不可超过20',
    请选择要删除的标签: '请选择要删除的标签！',
    模板中时段与电价被修改后数据将同步到已绑定的月份中请谨慎操作: '模板中时段与电价被修改后，数据将同步到已绑定的月份中，请谨慎操作！',
    展开全部: '展开全部',
    收起: '收起',
    时间编辑: '时间编辑',
    选择时间: '选择时间',
    时段说明: '时段说明',
    请选择: '请选择',
    新增: '新增',
    电价编辑: '电价编辑',

    买入价格: '买入价格',
    元: '元',
    卖出价格: '卖出价格',
    确定添加: '确定添加',
    请选择开始时间: '请选择开始时间！',
    开始时间不可与结束时间相同: '开始时间不可与结束时间相同！',
    选择结束时间: '选择结束时间！',
    结束时间不可与开始时间相同: '结束时间不可与开始时间相同！',
    请选择时间段类型: '请选择时间段类型！',
    请输入买入价格: '请输入买入价格！',
    '买入价格数字范围 0 - 10000': '买入价格数字范围 0 - 10000',
    小数点后不允许超过9位: '小数点后不允许超过9位',
    请输入卖出价格: '请输入卖出价格！',
    '卖出价格数字范围 0 - 10000': '卖出价格数字范围 0 - 10000',
    时间段存在冲突请重新配置: '时间段存在冲突请重新配置！',

    同步电价: '同步电价',
    请选择地区时区和起始时间后点击同步电价按钮平台将自动把对应电价数据与站点电价表同步: '请选择地区、时区和起始时间后，点击同步电价按钮，平台将自动把对应电价数据与站点电价表同步。',
    数据来源: '数据来源',
    国家: '国家',
    地区: '地区',
    起始日期: '起始日期',
    请确认是否将以下电价数据与电站同步: '请确认是否将以下电价数据与电站同步？',
    起始日: '起始日',
    否: '否',
    是: '是',

    当前同步电价未绑定到达同步日期后将停止更新电价信息请及时配置电价以免影响电站收益统计: '当前同步电价未绑定，到达同步日期后将停止更新电价信息，请及时配置电价，以免影响电站收益统计！',
    日期: '日期',
    选择日期: '选择日期',
    暂未配置电价请点击同步电价: '暂未配置电价，请点击同步电价',
    已同步至: '已同步至',
    列表: '列表',
    趋势: '趋势',
    电价: '电价',
    '请确认是否修改当前电价，修改后仅保留上传修改数据！': '请确认是否修改当前电价，修改后仅保留上传修改数据！',
    请输入电价: '请输入电价',
    '电价数值范围 1-9999 整数': '电价数值范围 1-9999 整数',
    电价表: '电价表',
    暂未获取到当日电价: '暂未获取到当日电价',
    请确认是否解除同步解除同步后将停止获取新的电价信息: '请确认是否解除同步，解除同步后将停止获取新的电价信息！'
  }
}
export default elecPriceZh
